import { NgClass } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
    booleanAttribute,
    computed,
    input,
} from '@angular/core';
import type { Icon } from '@hyundai/assets';

@Component({
    selector: 'a[ui-m010-c020-icon-link], button[ui-m010-c020-icon-link]',
    exportAs: 'iconLinkExternal',
    standalone: true,
    imports: [NgClass],
    templateUrl: './m010-c020-icon-link.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class]': 'classes()',
    },
})
export class M010C020IconLinkComponent {
    icon = input<Icon>();
    inverted = input(false, { transform: booleanAttribute });
    reversedOrder = input(false, { transform: booleanAttribute });
    alignCenter = input(false, { transform: booleanAttribute });
    mobileLabelBelow = input(false, { transform: booleanAttribute });

    classes = computed(
        () =>
            `group cursor-pointer flex-wrap flex items-center gap-8 max-w-full ${this.mobileLabelBelow() ? 'flex-col gap-y-5 md:flex-row ' : ''} ${this.reversedOrder() ? 'flex-row-reverse' : ''}`,
    );
}
